export default __webpack_public_path__ + "static/media/logo-mobile.72ff1470.webp";